var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStallionGender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5001 0C15.6716 0 15.0001 0.671576 15.0001 1.50001C15.0001 2.32844 15.6716 3.00001 16.5001 3.00001H18.8788L14.2149 7.66387C12.7437 6.61616 10.9438 5.99996 9.00004 5.99996C4.02946 5.99996 0 10.0294 0 15C0 19.9706 4.02946 24 9.00004 24C13.9706 24 18.0001 19.9706 18.0001 15C18.0001 13.0563 17.3839 11.2564 16.3362 9.78521L21.0001 5.12134V7.50004C21.0001 8.32847 21.6717 9.00004 22.5001 9.00004C23.3285 9.00004 24.0001 8.32847 24.0001 7.50004V1.50001C24.0001 0.671576 23.3285 0 22.5001 0H16.5001ZM9.00004 8.99997C5.68632 8.99997 3.00001 11.6863 3.00001 15C3.00001 18.3137 5.68632 21 9.00004 21C12.3138 21 15.0001 18.3137 15.0001 15C15.0001 11.6863 12.3138 8.99997 9.00004 8.99997Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStallionGender);
export default __webpack_public_path__ + "static/media/stallion-gender.3a8d14a8.svg";
export { ForwardRef as ReactComponent };